import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Moment from 'react-moment'
// import "./home.css"
class  Transaction extends Component {

    clickIfShow=()=>{
        // console.log("data=>>>>>>>>",this.props.data)
        this.props.clickIfShow1(this.props.data)
    }
  render() {
    //   console.log("data",this.props.checkoutData.selectedPayment)
    //    var array  = this.props.checkoutData.selectedPayment
    //     var total  = array.length
    //     console.log("leight =====---->array", total)

    return (
           
                    <a key={this.props.data._id} onClick={this.clickIfShow}>
                                                                
                        <li className="table-row" >
                            <div className="col col-1" data-label="Job Id">{this.props.data.checkoutData.fullname}</div>
                            <div className="col col-2" data-label="Customer Name">{this.props.data.checkoutData.email}</div>
                            <div className="col col-3" data-label="Amount">₦{this.props.data.checkoutData.amount}</div>
                            {/* <div className="col col-4" data-label="Payment Status">{trans.chargeStatus}</div> */}
                            <div className="col col-4" data-label="Payment Status"><Moment  format="YYYY/MM/DD" date={this.props.data.createdAt} /></div>
                        </li>
                  </a>
        
    )

}





}

export default  Transaction;


// WEBPACK FOOTER //
// ./src/component/activity/transactions.js